import { c as _c } from "react/compiler-runtime";
import { TextField } from "@mui/material";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
export default function EnquiryTextField(t0) {
  const $ = _c(58);
  const {
    label,
    value,
    onChange,
    onBlur,
    hasError,
    placeholder,
    readOnly,
    inputRef,
    multiline,
    helperText,
    errorMessage,
    icon,
    onClick,
    type,
    valueTitle
  } = t0;
  let t1;
  if ($[0] !== hasError || $[1] !== label || $[2] !== valueTitle) {
    t1 = valueTitle ? <><span className="m3-body-small mb-1" style={{
        color: hasError ? "var(--textErrorErrorText, #BA1A1A)" : "var(--textDisabledDisabled, #17191c59)"
      }}>{label}</span><span className="m3-body-large font-bold text-[--textPrimaryPrimary]">{valueTitle}</span></> : null;
    $[0] = hasError;
    $[1] = label;
    $[2] = valueTitle;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = type || "text";
  const t3 = valueTitle ? null : label;
  let t4;
  if ($[4] !== errorMessage || $[5] !== hasError || $[6] !== helperText) {
    t4 = hasError ? errorMessage : <span className="m3-body-small text-[--textSecondarySecondary]   ">{helperText}</span>;
    $[4] = errorMessage;
    $[5] = hasError;
    $[6] = helperText;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      className: "m3-body-large"
    };
    t6 = {
      disableUnderline: false
    };
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      inputLabel: t5,
      input: t6,
      formHelperText: {
        className: "m3-body-small",
        sx: {
          marginTop: "4px",
          marginLeft: 0,
          color: "var(--textErrorErrorText, #BA1A1A)"
        }
      }
    };
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = readOnly ? "pointer" : "text";
  let t10;
  let t11;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      visibility: "hidden",
      pointerEvents: "none"
    };
    t10 = {
      visibility: "hidden",
      pointerEvents: "none"
    };
    t11 = {
      visibility: "hidden",
      pointerEvents: "none"
    };
    $[11] = t10;
    $[12] = t11;
    $[13] = t9;
  } else {
    t10 = $[11];
    t11 = $[12];
    t9 = $[13];
  }
  let t12;
  if ($[14] !== multiline) {
    t12 = multiline && {
      whiteSpace: "pre-wrap",
      wordWrap: "break-word",
      overflowWrap: "break-word"
    };
    $[14] = multiline;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t12 || $[17] !== t8) {
    t13 = {
      fontSize: "16px",
      color: "var(--textPrimaryPrimary, #1B1C17)",
      cursor: t8,
      "&::-webkit-credentials-auto-fill-button": t9,
      "&::-webkit-contacts-auto-fill-button": t10,
      "&::-webkit-strong-password-auto-fill-button": t11,
      ...t12
    };
    $[16] = t12;
    $[17] = t8;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      cursor: "pointer",
      backgroundColor: "transparent"
    };
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  const t15 = hasError ? "var(--textErrorErrorText, #BA1A1A)" : "var(--textDisabledDisabled, #17191c59)";
  const t16 = hasError ? "var(--textErrorErrorText, #BA1A1A)" : "var(--colorPrimaryPrimary, #004BEE)";
  let t17;
  if ($[20] !== t16) {
    t17 = {
      color: t16
    };
    $[20] = t16;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== t15 || $[23] !== t17) {
    t18 = {
      fontSize: "16px",
      color: t15,
      "&.Mui-focused": t17
    };
    $[22] = t15;
    $[23] = t17;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  const t19 = hasError ? "3px solid var(--colorErrorError, #BA1A1A) !important" : "1px solid var(--colorOutlineOutline, #AEB7F9) !important";
  let t20;
  if ($[25] !== t19) {
    t20 = {
      borderBottom: t19
    };
    $[25] = t19;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  const t21 = hasError ? "3px solid var(--colorErrorError, #BA1A1A) !important" : "1px solid var(--colorOutlineOutline, #AEB7F9) !important";
  let t22;
  if ($[27] !== t21) {
    t22 = {
      borderBottom: t21
    };
    $[27] = t21;
    $[28] = t22;
  } else {
    t22 = $[28];
  }
  const t23 = hasError ? "var(--colorErrorError, #BA1A1A) !important" : "var(--colorPrimaryPrimary, #004BEE) !important";
  const t24 = hasError ? "3px !important" : "2px !important";
  let t25;
  if ($[29] !== t23 || $[30] !== t24) {
    t25 = {
      borderBottomColor: t23,
      borderBottomWidth: t24
    };
    $[29] = t23;
    $[30] = t24;
    $[31] = t25;
  } else {
    t25 = $[31];
  }
  let t26;
  if ($[32] !== t13 || $[33] !== t18 || $[34] !== t20 || $[35] !== t22 || $[36] !== t25) {
    t26 = {
      width: "292px",
      flex: 1,
      "& .MuiInputBase-input": t13,
      "& .MuiInputBase-input[readonly]": t14,
      "& .MuiInputLabel-root": t18,
      "& .MuiInput-underline:before": t20,
      "& .MuiInput-underline:hover:before": t22,
      "& .MuiInput-underline:after": t25
    };
    $[32] = t13;
    $[33] = t18;
    $[34] = t20;
    $[35] = t22;
    $[36] = t25;
    $[37] = t26;
  } else {
    t26 = $[37];
  }
  let t27;
  if ($[38] !== hasError || $[39] !== inputRef || $[40] !== multiline || $[41] !== onBlur || $[42] !== onChange || $[43] !== onClick || $[44] !== placeholder || $[45] !== readOnly || $[46] !== t2 || $[47] !== t26 || $[48] !== t3 || $[49] !== t4 || $[50] !== value) {
    t27 = <TextField type={t2} label={t3} value={value} onChange={onChange} onClick={onClick} onBlur={onBlur} error={hasError} helperText={t4} placeholder={placeholder} readOnly={readOnly} inputRef={inputRef} multiline={multiline} variant="standard" slotProps={t7} sx={t26} />;
    $[38] = hasError;
    $[39] = inputRef;
    $[40] = multiline;
    $[41] = onBlur;
    $[42] = onChange;
    $[43] = onClick;
    $[44] = placeholder;
    $[45] = readOnly;
    $[46] = t2;
    $[47] = t26;
    $[48] = t3;
    $[49] = t4;
    $[50] = value;
    $[51] = t27;
  } else {
    t27 = $[51];
  }
  let t28;
  if ($[52] !== t1 || $[53] !== t27) {
    t28 = <div className="flex flex-col">{t1}{t27}</div>;
    $[52] = t1;
    $[53] = t27;
    $[54] = t28;
  } else {
    t28 = $[54];
  }
  let t29;
  if ($[55] !== icon || $[56] !== t28) {
    t29 = <div className="flex items-center gap-2">{icon}{t28}</div>;
    $[55] = icon;
    $[56] = t28;
    $[57] = t29;
  } else {
    t29 = $[57];
  }
  return t29;
}